/**
 * @generated SignedSource<<35aa52b8b418d258221c564600bd5251>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
import { FragmentRefs } from "relay-runtime";
export type RoundControls_Booking$data = {
  readonly __typename: string;
  readonly startSlot: {
    readonly agenda: {
      readonly facility: {
        readonly type: FacilityType;
      };
    };
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"DurationRoundControls_Booking" | "GolfRoundControls_Booking">;
  readonly " $fragmentType": "RoundControls_Booking";
};
export type RoundControls_Booking$key = {
  readonly " $data"?: RoundControls_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoundControls_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoundControls_Booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GolfRoundControls_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DurationRoundControls_Booking"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "3d1379f4cf97350cccf96de3247f2576";

export default node;
